
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hplc': {
    width: 16,
    height: 16,
    viewBox: '0 0 825.26 686.56',
    data: '&quot;<path pid="0" class="cls-1" d="M755.46 40.18H69.8a24 24 0 0 0-24 24v426.13a24 24 0 0 0 24 23.95h312.89v72.24H262.92a29.94 29.94 0 0 0 0 59.88h286.69a29.94 29.94 0 0 0 0-59.88h-107v-72.24h312.85a24 24 0 0 0 23.95-23.95V64.14a24 24 0 0 0-23.95-23.96zm-24 426.17H93.75V342.58h186.86l22.25-47.51 8.71 22.84L322 343.28h60l6.31-25.37 23.3-100 36.74 125.69h22.2L501 308.1l25.62 32.77h204.89zm0-151.11H539.09l-37.18-47.55-36.66 42.65L408.73 117l-46.82 201H339l-33.72-88.45-41 87.48H93.75V88.09h637.76z"/>'
  }
})
